module.exports = __webpack_public_path__ + "img/bulkRtpAssignment.c7a0057b.jpg";